import React, { useEffect, useState } from 'react';
import { useRequestsContext } from '../../../common/hooks/requestHook';
import { PageWrapper, FlexRow, FlexCol } from './callingInformation.styles';
import { SearchBarRaw } from '@/common/styles/SearchBars';
import SelectInput from '@/common/components/SelectInput';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { Colors } from '@/common/colors/colors';
import { CONSULTANT_ROLES } from '@/common/constants/consultantRoles';
import { useFormik } from 'formik';
import Input from '@/common/components/Input';
import ActionButton from '@/common/components/buttons/ActionButton';
import moment from 'moment';
import { getCallingInformation } from '@/API/repositories/calling';
import {
	VOIP_PROVIDERS,
	VOIP_PROVIDER,
} from '@/common/constants/voipProviders';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import Loading from '@/common/components/Loading';
import CallingInformationTable from './components/CallingInformationTable';

const CallingInformation = () => {
	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const { options, filterUsersByRoles, commonData } = useCommonDataContext();
	const { users } = commonData;
	const { queuesOptions } = options;
	const [consultants, setConsultants] = useState([]);
	const [data, setData] = useState([]);
	const { addMessage } = useMessageQueueContext();

	const formik = useFormik({
		initialValues: {
			consultants: [],
			providers: [{ value: VOIP_PROVIDER.TWILIO, label: VOIP_PROVIDER.TWILIO }],
			from: '',
			to: '',
		},
		onSubmit: (values) => handleSearch(values),
	});

	useEffect(() => {
		loadData();
	}, [users]);

	const loadData = async () => {
		setConsultants(() => filterUsersByRoles(CONSULTANT_ROLES));
	};

	const handleSearch = async (values) => {
		if (
			!values.from ||
			!values.to ||
			values.consultants.length === 0 ||
			values.consultants.length === 0
		) {
			addMessage('Fill all fields');
			return;
		}
		const payload = {
			from: moment(values.from).toISOString(),
			to: moment(values.to).toISOString(),
			consultants: values?.consultants?.map((c) => c.value),
			providers: values.providers?.map((p) => p.value),
		};

		const response = await makeRequest(
			getCallingInformation.bind(null, payload),
		);

		if (response.data) {
			setData(() =>
				response.data.sort(
					(a, b) =>
						new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
				),
			);
		}
	};

	const handleSelectedQueues = (queues) => {
		let selectedUsersIds = [];

		queues.forEach((data) => {
			selectedUsersIds = [...selectedUsersIds, ...data.value.consultants];
		});

		formik.setFieldValue(
			'consultants',
			consultants.filter((c) => selectedUsersIds.includes(c.value)),
		);

		formik.setFieldValue('queues', queues);
	};

	return (
		<PageWrapper>
			{hasUnfilledRequest(getCallingInformation) && <Loading />}
			<SearchBarRaw>
				<FlexRow>
					<FlexCol>
						<Input
							id='from'
							name='From'
							type='datetime-local'
							inputWidth={180}
							color={Colors.darkBlue}
							width={50}
							value={formik.values.from}
							onChange={formik.handleChange}
							required={true}
						/>

						<Input
							id='to'
							name='To'
							type='datetime-local'
							width={50}
							inputWidth={180}
							color={Colors.darkBlue}
							value={formik.values.to}
							onChange={formik.handleChange}
							required={true}
						/>
						<SelectInput
							name={'Providers'}
							id='providers'
							selected={formik.values.providers}
							setSelected={(value) => formik.setFieldValue('providers', value)}
							options={VOIP_PROVIDERS.map((p) => ({
								value: p,
								label: p,
							}))}
							width={120}
							multiple={true}
							inputWidth={220}
							color={Colors.darkBlue}
							required
						/>
					</FlexCol>
					<FlexCol>
						<SelectInput
							name={'Consultants'}
							id='consultants'
							selected={formik.values.consultants}
							setSelected={(value) =>
								formik.setFieldValue('consultants', value)
							}
							options={consultants}
							width={140}
							multiple={true}
							inputWidth={220}
							color={Colors.darkBlue}
							required
						/>
						<SelectInput
							name={'Queue'}
							id='queue'
							selected={formik.values.queues}
							setSelected={handleSelectedQueues}
							options={queuesOptions}
							width={140}
							multiple={true}
							inputWidth={220}
							color={Colors.darkBlue}
						/>
					</FlexCol>
				</FlexRow>
				<ActionButton defaultText='Search' onClick={formik.handleSubmit} />
			</SearchBarRaw>
			<CallingInformationTable data={data} />
		</PageWrapper>
	);
};

export default CallingInformation;
